import React from "react";
import {
  Modal,
  ModalContent,
  ModalBody,
  Button,
  useDisclosure,
} from "@nextui-org/react";
import useWindowSize from "@/helpers/hooks/useWindowSize";
import CustomButton from "../common/button";
import { MediaPlayer, MediaProvider } from "@vidstack/react";
import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from "@vidstack/react/player/layouts/default";
import { MdClose } from "react-icons/md";
import { PERSIAN } from "../player/player.elements";
import validator from "validator";
import "@/styles/player.css";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";

const deviceSizeGuide = {
  SM: "",
  MD: "3xl",
  LG: "5xl",
};

const PreviewModal = ({ src }) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const device = useWindowSize();

  function isValidVideoURL(url) {
    const videoExtensions = /\.(mp4|mov|avi|wmv|flv|webm|mkv|m4v)$/i;
    return validator.isURL(url) && videoExtensions.test(url);
  }

  function isCMSURL(url) {
    const pattern =
      /^https:\/\/cms-api\.manabakh\.ir\/v1\/cms\/api\/content-media\/[^/]+\/video$/;
    return pattern.test(url);
  }

  function extractFilename(text) {
    const match = text.match(/\/content-media\/([^/]+)\/video$/);
    return match ? match[1] || match[0] : null;
  }

  if (!src) {
    return null;
  } else if (src && !isCMSURL(src) && !isValidVideoURL(src)) {
    return null;
  }

  return (
    <>
      <CustomButton
        onClick={onOpen}
        label="پیش نمایش"
        textColor="text-primary-white"
        classNames="content-detail-secondary-action content-detail-preview-action bg-[#262626]"
      />
      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        size={deviceSizeGuide[device]}
        placement="center"
        hideCloseButton
        shouldBlockScroll
      >
        <ModalContent className="!p-0 !m-0 max-h-[90vh]">
          {(onClose) => (
            <div dir="ltr">
              <ModalBody className="relative !p-0 max-h-[90vh]">
                <div className="absolute top-5 left-5 z-50">
                  <Button isIconOnly onClick={onClose} aria-label="بستن پیش نمایش">
                    <MdClose color="whitesmote" />
                  </Button>
                </div>
                <MediaPlayer
                  className="w-full h-full max-h-[90vh]"
                  src={[{ src, type: "video/mp4" }]}
                  crossOrigin
                  playsInline
                  autoPlay
                >
                  <MediaProvider />
                  <DefaultVideoLayout
                    icons={defaultLayoutIcons}
                    translations={PERSIAN}
                    slots={{
                      airPlayButton: null,
                      googleCastButton: null,
                      captionsButton: null,
                      fullscreenButton: null,
                      pipButton: null,
                      settingsMenu: null,
                    }}
                  />
                </MediaPlayer>
              </ModalBody>
            </div>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default PreviewModal;
